/* eslint-disable vue/no-parsing-error */
<template>
  <div class="content">
    <section v-if="details != ''" class="info">
      <h2>{{ details.name }}</h2>
      <ul>
        <li>
          <label>费用金额：</label>
          <p>{{ Number(details.amount) + "元" }}</p>
        </li>
        <li v-show="details.type == 1 && details.status != 20">
          <label>开票金额：</label>
          <p>{{ Number(details.invoice_amount) + "元" }}</p>
        </li>
        <li v-show="details.type == 1 && details.status != 20">
          <label>开票日期：</label>
          <p  v-if="details.invoice_date">
            {{ details.invoice_date.substring(0, 10) }}
          </p>
        </li>
        <li>
          <label>费用总金额：</label>
          <p>
            {{ Number(details.amount) + Number(details.pay_service) + "元" }}
          </p>
        </li>
        <li v-show="details.status == 42 || details.status == 50">
          <label>{{ details.type == 1 ? "入账金额：" : "出帐金额：" }}</label>
          <p>{{ Number(details.finance_flow_total) + "元" }}</p>
        </li>
        <!-- <br /> -->

        <br />
        <li v-show="details.type == 2 && details.status == 50">
          <label>发薪平台：</label>
          <p v-show="details.is_platform == 1">未使用</p>
          <p v-show="details.is_platform == 2">使用</p>
        </li>
        <li
          v-show="
            details.type == 2 &&
              details.status == 50 &&
              details.is_platform == 2
          "
        >
          <label>发薪平台名称：</label>
          <p>{{ details.finance_platform_name }}</p>
        </li>
        <li
          v-show="
            details.type == 2 &&
              details.status == 50 &&
              details.is_platform == 2
          "
        >
          <label>发薪手续费：</label>
          <p>{{ details.pay_service }}</p>
        </li>
        <li>
          <label>费用归属日期：</label>
          <p  v-if="details.finance_date">
            {{ details.finance_date.substring(0, 10) }}
          </p>
        </li>
        <br />
        <li>
          <label>结算类型：</label>
          <p v-if="details.type == 1">应收</p>
          <p v-else-if="details.type == 2">应付</p>
          <p v-else>未知</p>
        </li>
        <br />
        <li>
          <label>费用类型：</label>
          <p>{{ details.pname + "-" + details.finance_type_name }}</p>
        </li>
        <br />
        <li>
          <label>项目：</label>
          <p>{{ details.project_name }}</p>
        </li>
        <li>
          <label>提交时间：</label>
          <p>{{ details.create_time }}</p>
        </li>
        <li>
          <label>票据：</label>
          <p v-if="details.is_ticket == 2">票据齐全</p>
          <p v-else>票据不全</p>
        </li>
        <br />
        <li>
          <label>费用编号：</label>
          <p>{{ details.no }}</p>
        </li>
        <li v-show="details.from_type == 2">
          <label>报销编号：</label>
          <p>{{ details.bx_no }}</p>
        </li>
        <li v-show="details.bank_flow_num != ''">
          <label>银行流水编号：</label>
          <p>{{ details.bank_flow_num }}</p>
        </li>
        <br />
        <li style="width: 80%">
          <label>费用明细：</label>
          <p>{{ details.detail }}</p>
        </li>
        <br />
        <li>
          <label>状态：</label>
          <p v-show="details.status == 20">待项目负责人审核</p>
          <p v-show="details.status == 21">项目负责人驳回</p>
          <p v-show="details.type == 1 && details.status == 30">待开票</p>
          <p v-show="details.type == 2 && details.status == 30">待财务审核</p>
          <p v-show="details.status == 31">财务驳回</p>
          <p v-show="details.type == 1 && details.status == 40">待入账</p>
          <p v-show="details.type == 2 && details.status == 40">待出账</p>
          <p v-show="details.type == 1 && details.status == 42">已入账</p>
          <p v-show="details.type == 2 && details.status == 42">已出账</p>
          <p v-show="details.status == 41">出纳驳回</p>
          <p v-show="details.status == 50">结算完成</p>
          <p v-show="details.status == 100">已作废</p>
        </li>
        <br />
        <!--<li v-show="details.status == 100">-->
        <!--<label>作废原因：</label>-->
        <!--</li>-->
        <!--<br v-show="details.status == 100" />-->

        <li>
          <label>提交人员：</label>
          <p>{{ details.create_user_name }}</p>
        </li>
        <!-- <li v-show="details.status == 42 || details.status == 50">
          <label>未到帐金额：</label>
          <p>
            {{
              // eslint-disable-next-line vue/no-parsing-error
              Number(details.finance_remaining_amount) < 0
                ? "0元"
                : Number(details.finance_remaining_amount) + "元"
            }}
          </p>
        </li> -->
        <li>
          <label>签约主体：</label>
          <p>{{ details.company_name }}</p>
        </li>
        <li>
          <label>客户名称：</label>
          <p>{{ details.customer_name }}</p>
        </li>
        <li v-show="details.from_type == 2">
          <label>打款至：</label>
          <p v-show="details.out_account_type == 1">
            {{ details.create_user_name }}
          </p>
          <p v-show="details.out_account_type == 2">员工</p>
          <p v-show="details.out_account_type == 3">三方</p>
          <p v-show="details.out_account_type == 4">其他</p>
          <p v-show="details.out_account_type == 0">未知</p>
        </li>
        <li
          class="workerStyle"
          v-show="details.from_type == 2 && details.guard_list != ''"
        >
          <table>
            <thead>
              <th>员工姓名</th>
              <th>身份证号</th>
              <th>银行名称</th>
              <th>银行卡号</th>
              <th>工时/件数</th>
              <th>结算金额</th>
            </thead>
            <tbody>
              <tr v-for="(item, k) in details.guard_list" :key="k">
                <td>{{ item.name }}</td>
                <td>{{ item.idcard }}</td>
                <td>{{ item.bank_name }}</td>
                <td>{{ item.bank_card_number }}</td>
                <td>{{ item.hours }}</td>
                <td>{{ item.amount }}</td>
              </tr>
            </tbody>
          </table>
        </li>
        <br v-show="details.from_type == 2 && details.out_account_type == 3" />
        <li
          v-show="details.from_type == 2 && details.out_account_type == 3"
          class="workerStyle thirdStyle"
        >
          <ul>
            <li
              v-if="
                details.third_part_info != undefined &&
                  details.third_part_info != ''
              "
            >
              <div v-show="details.third_part_info.type == 1">
                <label>公司名称：</label>
                <p>{{ details.third_part_info.name }}</p>
              </div>
              <div v-show="details.third_part_info.type == 1">
                <label>公司地址：</label>
                <p>{{ details.third_part_info.company_address }}</p>
              </div>
              <div v-show="details.third_part_info.type == 1">
                <label>纳税人识别号：</label>
                <p>{{ details.third_part_info.taxpayer }}</p>
              </div>
              <div>
                <label>联系人姓名：</label>
                <p>{{ details.third_part_info.contact_name }}</p>
              </div>
              <div>
                <label>联系人手机号：</label>
                <p>{{ details.third_part_info.contact_phone }}</p>
              </div>
              <div v-show="details.third_part_info.type == 2">
                <label>身份证号：</label>
                <p>{{ details.third_part_info.idcard }}</p>
              </div>
              <div>
                <label>银行名称：</label>
                <p>{{ details.third_part_info.bank_name }}</p>
              </div>
              <div>
                <label>支行名称：</label>
                <p>{{ details.third_part_info.bank_branch }}</p>
              </div>
              <div>
                <label>银行账号：</label>
                <p>{{ details.third_part_info.bank_no }}</p>
              </div>
            </li>
          </ul>
        </li>
        <br v-show="details.from_type == 2 && details.out_account_type == 4" />
        <li
          v-show="details.from_type == 2 && details.out_account_type == 4"
          class="workerStyle"
        >
          <label>其他账户信息：</label>
          <p>{{ details.other_info }}</p>
        </li>
        <br v-show="details.from_type == 2 && accessory != ''" />
        <li
          v-show="details.from_type == 2 && accessory != ''"
          class="accessoryStyle"
        >
          <label>附件：</label>
          <viewer :images="accessory">
            <img
              class="imgStyle"
              v-for="src in accessory"
              :src="src.url"
              :key="src.id"
            />
          </viewer>
        </li>
        <br v-show="details.from_type == 1 && xn_accessory != ''" />
        <li v-show="details.from_type == 1">
          <label>打款至：</label>
          <p v-show="details.xf_out_account_type == 1">
            {{ details.create_user_name }}
          </p>
          <p v-show="details.xf_out_account_type == 2">员工</p>
          <p v-show="details.xf_out_account_type == 3">三方</p>
          <p v-show="details.xf_out_account_type == 4">其他</p>
          <p v-show="details.xf_out_account_type == 0">未知</p>
        </li>
        <br
          v-show="details.from_type == 1 && details.xf_out_account_type == 3"
        />
        <li
          v-show="details.from_type == 1 && details.xf_third_part_info != ''"
          class="workerStyle thirdStyle"
        >
          <ul>
            <li
              v-if="
                details.xf_third_part_info != undefined &&
                  details.xf_third_part_info != ''
              "
            >
              <div v-show="details.xf_third_part_info.type == 1">
                <label>公司名称：</label>
                <p>{{ details.xf_third_part_info.name }}</p>
              </div>
              <div v-show="details.xf_third_part_info.type == 1">
                <label>公司地址：</label>
                <p>{{ details.xf_third_part_info.company_address }}</p>
              </div>
              <div v-show="details.xf_third_part_info.type == 1">
                <label>纳税人识别号：</label>
                <p>{{ details.xf_third_part_info.taxpayer }}</p>
              </div>
              <div>
                <label>联系人姓名：</label>
                <p>{{ details.xf_third_part_info.contact_name }}</p>
              </div>
              <div>
                <label>联系人手机号：</label>
                <p>{{ details.xf_third_part_info.contact_phone }}</p>
              </div>
              <div v-show="details.xf_third_part_info.type == 2">
                <label>身份证号：</label>
                <p>{{ details.xf_third_part_info.idcard }}</p>
              </div>
              <div>
                <label>银行名称：</label>
                <p>{{ details.xf_third_part_info.bank_name }}</p>
              </div>
              <div>
                <label>支行名称：</label>
                <p>{{ details.xf_third_part_info.bank_branch }}</p>
              </div>
              <div>
                <label>银行账号：</label>
                <p>{{ details.xf_third_part_info.bank_no }}</p>
              </div>
            </li>
          </ul>
        </li>
        <br
          v-show="details.from_type == 1 && details.xf_out_account_type == 4"
        />
        <li
          v-show="details.from_type == 1 && details.xf_out_account_type == 4"
          class="workerStyle"
        >
          <label>其他账户信息：</label>
          <p>{{ details.xf_other_info }}</p>
        </li>
        <br />
        <li
          v-show="details.from_type == 1 && xn_accessory != ''"
          class="accessoryStyle"
        >
          <label>附件：</label>
          <viewer :images="xn_accessory">
            <img
              class="imgStyle"
              v-for="src in xn_accessory"
              :src="src.url"
              :key="src.id"
            />
          </viewer>
        </li>
        <br v-show="details.from_type == 1 && accessory != ''" />
        <li v-show="details.status != 100 && userBOSS">
          <a-button
            @click="showIsHandleCancel = !showIsHandleCancel"
            style="background: #f56c6c; color: #fff"
            class="handleCost"
            type="danger"
            >费用作废</a-button
          >
        </li>
      </ul>
      <div class="cancellation" v-show="details.status == 100">
        <img src="../../assets/money/zuofei.png" alt="" />
      </div>
    </section>
    <section v-if="details != '' && details.sort_check_record != ''">
      <h3>审核信息</h3>
      <a-button
        v-show="details.status == 50 || details.status == 42"
        class="resetStyle"
        @click="doPrint()"
      >
        <a-icon type="printer" />打印
      </a-button>
      <a-steps
        :current="activeStep"
        direction="vertical"
        class="auditStyle"
        size="small"
      >
        <a-step v-for="item in details.sort_check_record" :key="item.id">
          <a-icon
            v-if="item.result_status == 1"
            slot="icon"
            type="check-circle"
            style="color: #67c23a"
          />
          <a-icon
            v-else-if="item.result_status == 2"
            slot="icon"
            type="exclamation-circle"
            style="color: #f56c6c"
          />
          <a-icon
            v-else
            type="question-circle"
            slot="icon"
            style="color: #e6a23c"
          />
          <template slot="title">
            <p v-show="item.record_from_type == 2 && item.to_status == 10">
              提交申请
            </p>
            <p v-show="item.record_from_type == 2 && item.to_status == 11">
              项目经理驳回
            </p>
            <p v-show="item.record_from_type == 2 && item.to_status == 20">
              项目经理审核通过
            </p>
            <p v-show="item.record_from_type == 2 && item.to_status == 21">
              项目总监驳回
            </p>
            <p v-show="item.record_from_type == 2 && item.to_status == 30">
              项目总监审核通过
            </p>
            <p v-show="item.record_from_type == 2 && item.to_status == 31">
              项目总监驳回
            </p>
            <p v-show="item.record_from_type == 1 && item.to_status == 20">
              提交申请
            </p>
            <p v-show="item.record_from_type == 1 && item.to_status == 21">
              项目负责人驳回
            </p>
            <p v-show="item.record_from_type == 1 && item.to_status == 30">
              项目负责人审核通过
            </p>
            <p v-show="item.record_from_type == 1 && item.to_status == 31">
              财务驳回
            </p>
            <p v-show="item.record_from_type == 1 && item.to_status == 40">
              财务审核通过
            </p>
            <p v-show="item.record_from_type == 1 && item.to_status == 41">
              出纳驳回
            </p>
            <p v-show="item.record_from_type == 1 && item.to_status == 50">
              结算完成
            </p>
            <p v-show="item.record_from_type == 1 && item.to_status == 100">
              费用作废
            </p>
          </template>
          <div slot="description" class="description">
            <span>
              <label>{{
                item.check_type == 0 ? "提交人：" : "审核人："
              }}</label>
              <p>
                {{ item.user_name }}
              </p>
            </span>
            <span>
              <label>{{
                item.to_status == 10 ? "申请时间：" : "操作时间："
              }}</label>
              <p>{{ item.create_time }}</p>
            </span>
            <span v-show="item.result_status == 2">
              <label>驳回原因：</label>
              <p>{{ item.reason }}</p>
            </span>
            <span v-if="details.type == 1">
              <label>开票日期：</label>
              <p  v-if="item.invoice_date">
                {{ item.invoice_date.substring(0, 10) }}
              </p>
            </span>
            <br v-if="item.to_status == 50 || item.to_status == 42" />
            <span v-if="item.to_status == 50 || item.to_status == 42">
              <label>{{
                details.type == 1 ? "入账日期：" : "出账日期："
              }}</label>
              <p  v-if="item.flow_date">
                {{ item.flow_date.substring(0, 10) }}
              </p>
            </span>
            <span v-show="item.to_status == 50 || item.to_status == 42">
              <label>{{
                details.type == 1 ? "入账账户：" : "出账账户："
              }}</label>
              <p>{{ item.company_name }}</p>
            </span>
            <span v-show="item.to_status == 50 || item.to_status == 42">
              <label>{{
                details.type == 1 ? "入账金额：" : "出账金额："
              }}</label>
              <p>{{ Number(item.amount) + "元" }}</p>
            </span>
            <span v-show="item.to_status == 50 || item.to_status == 42">
              <label>备注：</label>
              <p>{{ item.remark }}</p>
            </span>
            <span v-show="details.type == 1 && item.to_status == 40">
              <label>开票金额：</label>
              <p>{{ Number(item.invoice_amount) + "元" }}</p>
            </span>
          </div>
        </a-step>
      </a-steps>
    </section>
    <!-- 打印 -->
    <aside
      id="printData"
      v-if="
        details != '' &&
          isShowPrint &&
          (details.status == 50 || details.status == 42)
      "
    >
      <div style="margin:60px">
        <div
          style="position: relative;"
          v-for="(item, index) in details.sort_check_record"
          :key="item.id"
        >
          <div style="display:inline-block; margin-top: 20px;margin-right:20px">
            <a-icon
              v-if="item.result_status == 1"
              slot="icon"
              type="check-circle"
              style="color: #67c23a;display:inline-block"
            />
            <a-icon
              v-else-if="item.result_status == 2"
              slot="icon"
              type="exclamation-circle"
              style="color: #f56c6c;display:inline-block"
            />
            <a-icon
              v-else
              type="question-circle"
              slot="icon"
              style="color: #e6a23c;display:inline-block"
            />
            <span
              v-show="index + 1 != details.sort_check_record.length"
              style="position: absolute;left:8px;top:40px;display:inline-block;width:1px;height: 70%;    background-color: rgba(0, 0, 0, 0.45);"
            ></span>
          </div>
          <div style="display:inline-block;vertical-align: top;">
            <div>
              <p v-show="item.record_from_type == 2 && item.to_status == 10">
                提交申请
              </p>
              <p v-show="item.record_from_type == 2 && item.to_status == 11">
                项目经理驳回
              </p>
              <p v-show="item.record_from_type == 2 && item.to_status == 20">
                项目经理审核通过
              </p>
              <p v-show="item.record_from_type == 2 && item.to_status == 21">
                项目总监驳回
              </p>
              <p v-show="item.record_from_type == 2 && item.to_status == 30">
                项目总监审核通过
              </p>
              <p v-show="item.record_from_type == 2 && item.to_status == 31">
                项目总监驳回
              </p>
              <p v-show="item.record_from_type == 1 && item.to_status == 20">
                提交申请
              </p>
              <p v-show="item.record_from_type == 1 && item.to_status == 21">
                项目负责人驳回
              </p>
              <p v-show="item.record_from_type == 1 && item.to_status == 30">
                项目负责人审核通过
              </p>
              <p v-show="item.record_from_type == 1 && item.to_status == 31">
                财务驳回
              </p>
              <p v-show="item.record_from_type == 1 && item.to_status == 40">
                财务审核通过
              </p>
              <p v-show="item.record_from_type == 1 && item.to_status == 41">
                出纳驳回
              </p>
              <p v-show="item.record_from_type == 1 && item.to_status == 50">
                结算完成
              </p>
              <p v-show="item.record_from_type == 1 && item.to_status == 100">
                费用作废
              </p>
            </div>
            <div
              style="display:inline-block"
              slot="description"
              class="description"
            >
              <span style="margin-right:20px">
                <label
                  style="display:inline-block;color: rgba(0, 0, 0, 0.45);"
                  >{{ item.check_type == 0 ? "提交人：" : "审核人：" }}</label
                >
                <p style="display:inline-block;color: rgba(0, 0, 0, 0.45);">
                  {{ item.user_name }}
                </p>
              </span>
              <span style="margin-right:20px">
                <label
                  style="display:inline-block;color: rgba(0, 0, 0, 0.45);"
                  >{{
                    item.to_status == 10 ? "申请时间：" : "操作时间："
                  }}</label
                >
                <p style="display:inline-block;color: rgba(0, 0, 0, 0.45);">
                  {{ item.create_time }}
                </p>
              </span>
              <span v-show="item.result_status == 2" style="margin-right:20px">
                <label style="display:inline-block;color: rgba(0, 0, 0, 0.45);"
                  >驳回原因：</label
                >
                <p style="display:inline-block;color: rgba(0, 0, 0, 0.45);">
                  {{ item.reason }}
                </p>
              </span>
            </div>
          </div>
        </div>
      </div>
    </aside>
    <!-- 打印  end -->
    <!-- 作废费用 -->
    <aside class="dialogsBox" v-show="showIsHandleCancel">
      <div>
        <h3>费用作废</h3>
        <a @click="handleClose" class="close">
          <a-icon style="font-size: 30px; color: #666" type="close-circle" />
        </a>
        <ul>
          <li>
            <label>费用名称：</label>
            <p>{{ details.name }}</p>
          </li>
          <li>
            <label>结算类型：</label>
            <p v-if="details.type == 1">应收</p>
            <p v-else-if="details.type == 2">应付</p>
            <p v-else>未知</p>
          </li>
          <li>
            <label>费用金额：</label>
            <p>{{ Number(details.amount) + "元" }}</p>
          </li>
          <li>
            <label><i>*</i>作废原因：</label>
            <a-input style="width: 60%" v-model="reason" type="textarea" />
          </li>
        </ul>
        <div>
          <a-button type="primary" @click="handleSure"> 确定 </a-button>
        </div>
      </div>
    </aside>
    <!-- 作废费用 end -->
  </div>
</template>
<script>
import axios from "axios";
import "../../js/map/print";
export default {
  data() {
    return {
      details: {},
      activeStep: 0,
      isStatusVal: "process",
      handleCostVal: {},
      showIsHandleCancel: false,
      reason: "",
      accessory: [],
      xn_accessory: [],
      userBOSS: false,
      isShowPrint: false
    };
  },
  props: {
    detailsVal: {}
  },
  mounted() {
    let roleList = window.localStorage.getItem("xnserve-authority").split(",");
    this.userBOSS = roleList.includes("BOSS");
    if (this.detailsVal != undefined) {
      this.getDetails();
    }
  },
  watch: {
    detailsVal() {
      this.getDetails();
      // console.log(this.details);
    }
  },
  methods: {
    doPrint() {
      let prnHtml = document.getElementById("printData").innerHTML; //需要打印的内容
      const newWin = window.open(""); // 新打开一个空窗口
      newWin.document.body.innerHTML = prnHtml; //把需要打印的内容插入新窗口
      newWin.document.close(); //关闭文档输入流（window.close()和document.close()的区别）
      newWin.focus();

      // setTimeout(() => {
      //   //定时器等待，JS单线程，异步执行此行代码
      //   newWin.print();
      //   newWin.close(); //打印完成或取消，关闭新窗口
      // }, 200);
    },
    getDetails() {
      this.details = this.detailsVal;
      // console.log(this.details);
      if (this.details.images_url != "") {
        this.accessory = this.details.images_url;
      } else {
        this.accessory = [];
      }
      if (this.details.xf_images_fmt != "") {
        this.xn_accessory = this.details.xf_images_fmt;
      } else {
        this.xn_accessory = [];
      }
      if (this.details.sort_check_record != undefined) {
        this.activeStep = this.details.sort_check_record.length;
      } else {
        this.activeStep = 0;
      }
    },
    handleCancel() {
      let url =
        this.httpsBasic.url + this.httpsBasic.finance + "finance/invalid";
      axios
        .post(url, {
          id: this.details.id,
          reason: this.reason,
          token: window.localStorage.getItem("xnwfPcToken")
        })
        .then(res => {
          if (res.data.code == 200) {
            this.$message.success("操作成功");
            this.$emit("hideInHandle", false);
          } else {
            this.$message.warning(res.data.message);
          }
        });
    },
    handleSure() {
      let _this = this;
      if (this.reason != "") {
        this.showIsHandleCancel = false;
        this.$confirm({
          title: "费用作废",
          cancelText: "取消",
          okText: "确认",
          content: "费用一旦作废无法恢复，是否确认操作",
          onOk() {
            _this.handleCancel();
          },
          onCancel() {
            _this.reason = "";
          }
        });
      } else {
        this.$message.warning("请输入作废原因！");
      }
    },
    handleClose() {
      this.reason = "";
      this.showIsHandleCancel = false;
    }
  }
};
</script>
<style lang="less" scoped>
.content {
  padding: 30px 3%;
  > .info {
    h2 {
      font-size: 16px;
      margin-bottom: 10px;
      font-weight: normal;
    }
    > ul {
      margin-bottom: 30px;
      // margin: 0 20px 30px;
      > li {
        margin-bottom: 10px;
        display: inline-block;
        width: 33.3%;
        label,
        p,
        span {
          font-size: 14px;
          line-height: 20px;
          display: inline-block;
          vertical-align: top;
          max-width: 80%;
        }
      }
      .workerStyle {
        width: 100%;
        table {
          width: 100%;
          td,
          th {
            border: 1px solid #ccc;
            padding: 8px 12px;
            font-size: 14px;
            line-height: 18px;
            font-weight: normal;
          }
          th {
            background: #ededed;
          }
        }
        > ul {
          > li {
            div {
              display: inline-block;
              width: 33.3%;
              margin-bottom: 10px;
            }
            div:first-child,
            div:nth-child(2) {
              display: block;
            }
          }
        }
      }
      .thirdStyle {
        > ul {
          li {
            div:first-child,
            div:nth-child(2) {
              display: inline-block;
            }
          }
        }
      }
      .accessoryStyle {
        width: 100%;
        > div {
          display: inline-block;
          width: 60%;
          vertical-align: top;
        }
        img {
          width: 200px;
          height: 200px;
          object-fit: cover;
          border: 1px solid #ededed;
          margin-bottom: 10px;
          margin-left: 10px;
        }
      }
      .expenditure {
        width: 50%;
        table {
          width: 100%;
          th,
          td {
            border: 1px solid #ccc;
            padding: 4px 10px;
          }
          th {
            background: #f0f2f5;
          }
        }
      }
    }
  }
  .auditList {
    > span {
      display: block;
      // margin-left: 20px;
      margin-bottom: 10px;
      p,
      label {
        font-size: 14px;
        line-height: 20px;
        display: inline-block;
      }
    }
  }
  //   width: 100%;
  //   td,
  //   th {
  //     border: 1px solid #ccc;
  //     font-size: 14px;
  //     padding: 4px 6px;
  //   }
  //   th {
  //     background: #eee;
  //   }
  // }
  .handleCost {
    margin-top: 30px;
  }
}
</style>
<style lang="less">
.info {
  position: relative;
  .cancellation {
    position: absolute;
    right: 100px;
    top: 20px;
    img {
      height: 80px;
    }
  }
}

.auditStyle {
  margin: 20px;
  .ant-steps-item-finish
    > .ant-steps-item-container
    > .ant-steps-item-tail::after {
    background-color: rgba(0, 0, 0, 0.45);
    // background-color: #67C23A;
  }
  .description {
    > span {
      margin-right: 20px;
      display: inline-block;
      p,
      label {
        display: inline-block;
      }
    }
  }
}
</style>
